<template lang="pug">
  header.goq-header
    nav.navbar.p-0.fixed-top.goq-navbar
      Logo
      Controller(:url="url")
      Layout
      AppsButton
</template>

<script>
import Logo from './Logo'
import AppsButton from './AppsButton'
import Controller from './Controller'
import Layout from './Layout'

export default {
  name: 'Header',
  components: {
    Logo,
    AppsButton,
    Controller,
    Layout
  },
  props: ['url']
}
</script>
